/**
 * Duration (ms) of the fixture fade transition when navigating between fixtures in the
 * predict tab. Must match the `transition: opacity` duration on `.predict-content` in
 * both tenants' `predict-tab.scss` — that value is written there as a literal `150ms`
 * with a comment pointing back to this constant (SCSS cannot import a TS constant, so
 * keeping them in sync is manual; if you change this value, update both .scss files too).
 */
export const FIXTURE_FADE_DURATION_MS = 150;

/**
 * Duration (ms) the per-card "gespeichert"/saved feedback label stays visible after a
 * successful save. Must match the `animation` duration on `.saved-feedback-label--visible`
 * in `saved-feedback-label.scss` — that value is written there as a literal `1500ms` with a
 * comment pointing back to this constant (SCSS cannot import a TS constant, so keeping them
 * in sync is manual; if you change this value, update the .scss file too).
 */
export const SAVED_FEEDBACK_DURATION_MS = 1500;
